module.exports = __webpack_public_path__ + "img/5.babb4500.png";